<div class="px-10 py-8">
    <div class="pb-4 text-xl text-black leading-normal">
        {{ question }}
    </div>
    <p class="pb-4 text-sm text-current whitespace-pre-wra">{{ info }}</p>
    <div class="flex pt-3">
        <j-button className="btn-primary mr-2" (click)="manageIssue()">{{ actionName }}</j-button>
        <j-button className="'btn-empty'" (click)="closeModal()">{{'BUTTON.CANCEL' | translate}}</j-button>
    </div>
</div>
